import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import Layout from '../../../layout';

import "./index.scss"

const DashBoard = () => {
    const navigate = useNavigate();

    return (
        <Layout>

            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">

                        <div class="row">
                            <div class="col-sm-12">
                                <div class="home-tab">

                                    <div class="tab-content tab-content-basic">
                                        <div class="tab-pane fade show active" id="overview" role="tabpanel" aria-labelledby="overview">

                                            <div class="row">
                                                <div class="col-lg-4 d-flex flex-column">
                                                    <div class="row flex-grow">
                                                        <div class="col-md-12 col-lg-12 grid-margin stretch-card">
                                                            <div class="card bg-primary-staff card-rounded dashboard-card cursor-pointer" onClick={() => { navigate("/news") }}
                                                            >
                                                                <div class="card-body pb-0 text-center">
                                                                    <p class="status-summary-ight-white mb-1">
                                                                        {/* <i class="mdi mdi-account-multiple-plus"></i> */}
                                                                    </p>
                                                                    <h4 class="card-title card-title-dash text-white mb-4 text-center">News</h4>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 d-flex flex-column">
                                                    <div class="row flex-grow">
                                                        <div class="col-md-12 col-lg-12 grid-margin stretch-card">
                                                            <div class="card bg-primary-property card-rounded dashboard-card cursor-pointer" onClick={() => { navigate("/insights") }}>
                                                                <div class="card-body pb-0 text-center">
                                                                    <p class="status-summary-ight-white mb-1">
                                                                        {/* <i class="mdi mdi-home-modern"></i> */}
                                                                    </p>
                                                                    <h4 class="card-title card-title-dash text-white mb-4 text-center">Insights</h4>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-lg-4 d-flex flex-column">
                                                    <div class="row flex-grow">
                                                        <div class="col-md-12 col-lg-12 grid-margin stretch-card">
                                                            <div class="card bg-primary-area card-rounded dashboard-card cursor-pointer" onClick={() => { navigate("/tests") }}>
                                                                <div class="card-body pb-0 text-center">
                                                                    <p class="status-summary-ight-white mb-1">
                                                                        {/* <i class="mdi mdi-crop-landscape"></i> */}
                                                                    </p>
                                                                    <h4 class="card-title card-title-dash text-white mb-4 text-center">Tests</h4>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </Layout>
    )
}

export default DashBoard